const setOneWeekAgo = () => {
  const today = new Date();
  today.setDate(today.getDate() - 7);

  return Math.ceil(today.getTime() / 1000);
};

export default setOneWeekAgo;
